export const ItemMeta = {
  BODY: { label: "Armor", color: "#8D76A2" },
  FEET: { label: "Shoes", color: "#86A55F" },
  HEAD: { label: "Helmet", color: "#BF8146" },
  HAND: { label: "Weapon", color: "#7699B5" },
  UNDEFINED: { label: "Accessory", color: "#AEA086" },
  POTION: { label: "Potion", color: "#5C258F" },
};
